<template>
  <BlocksBlockRichText
    v-if="generalInternalStore.footer.bottomInfo"
    :data="generalInternalStore.footer.bottomInfo"
  />
</template>

<script setup lang="ts">
const generalInternalStore = useGeneralInternalStore();
</script>
